import { render, staticRenderFns } from "./string.vue?vue&type=template&id=bb8bf402&scoped=true&lang=pug&"
import script from "./string.vue?vue&type=script&lang=js&"
export * from "./string.vue?vue&type=script&lang=js&"
import style0 from "./string.vue?vue&type=style&index=0&id=bb8bf402&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8bf402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bb8bf402', component.options)
    } else {
      api.reload('bb8bf402', component.options)
    }
    module.hot.accept("./string.vue?vue&type=template&id=bb8bf402&scoped=true&lang=pug&", function () {
      api.rerender('bb8bf402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/string.vue"
export default component.exports